// extracted by mini-css-extract-plugin
export default {"tip":"tip_tip__xg0bd","content":"tip_content__Uk8tv"};